import { Check, X } from "lucide-react";
import { Reveal } from "./Reveal";

const IS = [
  "An AI knowledge layer",
  "A personal sales brain",
  "A system that works with existing tools",
  "Focused on high-value Sales IP",
  "A private instance with a curated, structured library that remains under your control",
];

const IS_NOT = [
  "Not a CRM",
  "Not another note-taking app",
  "Not a Gong-style conversation tool",
  "Not a replacement for salespeople",
  "Not an open frontier model agent that trains or refines shared models with your data",
];

export const WhatItIs = () => (
  <section id="what-it-is" className="relative py-12 md:py-20 border-t border-white/[0.05]" data-testid="what-it-is-section">
    <div className="mx-auto max-w-[1240px] px-6 md:px-12">
      <Reveal>
        <p className="text-sm font-medium tracking-widest uppercase text-teal mb-5">Positioning</p>
        <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-slate-50 leading-[1.08]">
          What it is, and what it isn't
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
        <Reveal>
          <div className="h-full rounded-2xl border border-teal/20 bg-teal/[0.04] p-8 md:p-10" data-testid="what-it-is-card">
            <h3 className="font-heading text-xl font-medium text-slate-100 mb-6">What it is</h3>
            <ul className="space-y-4">
              {IS.map((item) => (
                <li key={item} className="flex items-start gap-3.5">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-teal/15">
                    <Check className="h-3.5 w-3.5 text-teal" />
                  </span>
                  <span className="text-[15px] text-slate-200">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="h-full rounded-2xl border border-white/[0.07] bg-navy-surface p-8 md:p-10" data-testid="what-it-is-not-card">
            <h3 className="font-heading text-xl font-medium text-slate-400 mb-6">What it is not</h3>
            <ul className="space-y-4">
              {IS_NOT.map((item) => (
                <li key={item} className="flex items-start gap-3.5">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-white/[0.05]">
                    <X className="h-3.5 w-3.5 text-slate-500" />
                  </span>
                  <span className="text-[15px] text-slate-500">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <p className="mt-12 max-w-3xl font-heading text-2xl md:text-3xl font-light leading-snug text-slate-200">
          SalesMoat amplifies the salesperson's instincts and protects the details that actually win deals.
        </p>
      </Reveal>
    </div>
  </section>
);
